import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const types = [
  {
    title: "Server-Based",
    description:
      "Full-featured web application hosted on your server — ideal for admin offices, labs, and staff workstations with complete module access.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="4" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <rect x="3" y="14" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="7" cy="7" r="1" fill="currentColor" />
        <circle cx="7" cy="17" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Mobile App-Based",
    description:
      "Native mobile apps for students, parents, and teachers — access timetables, fees, attendance, and notifications on the go.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 18h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
];

const SmsDeploymentTypes: React.FC = () => {
  return (
    <section className="sms-deploy" aria-labelledby="sms-deploy-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="sms-deploy-title" className="wdev-section-head__title">
            Functionalities We Deliver
          </h2>
          <p className="sms-deploy__lead">
            Being a prominent web designing company in India we offer a complete set of
            functionalities for the best school management software in Bangalore to bring in high
            parent engagement and generate more admissions. We offer separate modules for the key
            stake players to carry out their functionalities online.
          </p>
        </AnimatedSection>

        <div className="sms-deploy__types">
          {types.map((type, index) => (
            <motion.article
              key={type.title}
              className="sms-deploy-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="sms-deploy-card__icon">{type.icon}</div>
              <h3>{type.title}</h3>
              <p>{type.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SmsDeploymentTypes;
